import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';

@Directive({
  selector: '[appFeatureFlag]',
})
export class FeatureFlagDirective implements OnInit {
  private _requiredFlag = '';
  private _isHidden = true;

  constructor(
    private readonly _templateRef: TemplateRef<unknown>,
    private readonly _viewContainer: ViewContainerRef,
    private readonly _featureFlagsService: FeatureFlagsService
  ) {}

  @Input() public set appFeatureFlag(feature: string) {
    if (feature) {
      this._requiredFlag = feature;
      this._updateView();
    }
  }

  ngOnInit() {
    this._updateView();
  }

  private _updateView() {
    if (this._checkValidity()) {
      if (this._isHidden) {
        this._viewContainer.createEmbeddedView(this._templateRef);
        this._isHidden = false;
      }
    } else {
      this._viewContainer.clear();
      this._isHidden = true;
    }
  }
  private _checkValidity() {
    return this._requiredFlag && this._featureFlagsService.isFeatureEnabled(this._requiredFlag);
  }
}
